import { render, staticRenderFns } from "./AddAdvertiser.vue?vue&type=template&id=ffb406fc&scoped=true"
import script from "./AddAdvertiser.vue?vue&type=script&lang=js"
export * from "./AddAdvertiser.vue?vue&type=script&lang=js"
import style0 from "./AddAdvertiser.vue?vue&type=style&index=0&id=ffb406fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb406fc",
  null
  
)

export default component.exports